// Redux Utils
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "@/features/auth/authThunks";
import {
  setHomeActive,
  setProfileActive,
} from "@/features/uiStates/mobileFixedBottomMenuSlice";

// React Utils
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

// Contextos
import { useModalsContext } from "@/contexts/ModalsContext";

// Components
import Modal from "@/components/Modals/Modal";
import InvitarAmigos from "@/components/Forms/InvitarAmigos";
import NavItems from "./NavItems";
import ActiveUsers from "./ActiveUsers";

// Assets
import Avatar1 from "@/assets/avatars/avatar_amanda.webp";
import Avatar2 from "@/assets/avatars/avatar_woman.webp";
import Avatar3 from "@/assets/avatars/avatar_man.webp";
import Avatar4 from "@/assets/avatars/avatar_man_2.webp";

// Utils
import { scrollToTop } from "@/lib/utilsUI";

// Example array options to render in the sidebar
const options = [
  { id: 1, icon: "home", title: "AppWhoop Tickets", url: "/" },
  {
    id: 2,
    icon: "users",
    title: "Club de embajadores",
    url: "#",
  },
  {
    id: 3,
    icon: "ticket",
    title: "Club de Beneficios",
    url: "#",
  },
  { id: 4, icon: "building", title: "Club de empresas", url: "#" },
  // {
  //   id: 5,
  //   icon: "question-circle",
  //   title: `Club de Artistas`,
  //   url: "#",
  // },
];

// Mock data for active users
const usersMock = [
  {
    id: 1,
    name: "Trinidad Fernandez",
    role: "Embajador",
    time: 1,
    avatar: Avatar2,
    followed: true,
    popularity: 50,
    activityScore: 90,
    active: true,
  },
  {
    id: 2,
    name: "Paraíso Music Fest",
    role: "Empresa / Eventos",
    time: 2,
    avatar: Avatar3,
    followed: false,
    popularity: 100,
    activityScore: 80,
    active: true,
  },
  {
    id: 3,
    name: "Pierre Ford",
    role: "Embajador",
    time: 4,
    avatar: Avatar3,
    followed: false,
    popularity: 40,
    activityScore: 70,
    active: true,
  },
  {
    id: 4,
    name: "Dj Steve",
    role: "Artista",
    time: 3,
    avatar: Avatar4,
    followed: false,
    popularity: 60,
    activityScore: 85,
    active: true,
  },
  {
    id: 5,
    name: "Dj Jobs",
    role: "Artista",
    time: 3,
    avatar: Avatar4,
    followed: false,
    popularity: 30,
    activityScore: 40,
    active: true,
  },
  {
    id: 6,
    name: "Dj Steve",
    role: "Artista",
    time: 3,
    avatar: Avatar4,
    followed: false,
    popularity: 60,
    activityScore: 85,
    active: true,
  },
  {
    id: 7,
    name: "Dj Jobs",
    role: "Artista",
    time: 3,
    avatar: Avatar4,
    followed: false,
    popularity: 30,
    activityScore: 40,
    active: true,
  },
];

export default function Sidebar({ isOpen, setIsOpen }) {
  // Redux dispatch
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  // React state for modals
  const { modals, openModal, closeModal } = useModalsContext();
  // State to track the active navigation item
  const [isActiveNavItem, setIsActiveNavItem] = useState(() => {
    const currentPath = window.location.pathname;
    const activeOption = options.find((option) => option.url === currentPath);
    return activeOption ? activeOption.id : null;
  });
  // Function to toggle the sidebar open/close state
  const toggleSidebar = () => {
    setIsOpen((open) => !open);
  };
  const handleNavItemClick = (title) => {
    setIsActiveNavItem(title);
    if (window.innerWidth <= 640) toggleSidebar();
  };
  useEffect(() => {
    setIsActiveNavItem(() => {
      const currentPath = window.location.pathname;
      const activeOption = options.find((option) => option.url === currentPath);
      return activeOption ? activeOption.id : null;
    });
  }, [isOpen]);

  return (
    <>
      <div
        className={`bg-aw-bluedark-95 sm:bg-aw-bluedark-50 text-white py-4 duration-300 transition-width absolute to sm:relative ${
          isOpen
            ? "w-full sm:w-64 opacity-100 z-[110] sm:z-[90]"
            : "w-0 opacity-0 sm:w-16 sm:opacity-100"
        } h-full border-r border-aw-bgbluedark transition-width duration-500`}
      >
        {/* <div className={`hidden sm:flex items-center justify-end mb-4`}>
        {isOpen ? (
          <button onClick={toggleSidebar} className="text-neutral-200 pr-3">
            <FontAwesomeIcon icon="fa-solid fa-chevron-left " />
          </button>
        ) : (
          <button onClick={toggleSidebar} className="text-neutral-200 pr-3">
            <FontAwesomeIcon icon="fa-solid fa-chevron-right " />
          </button>
        )}
      </div> */}
        {/* Desktop */}
        <div
          className={`hidden sm:flex flex-col items-start justify-between space-x-2 w-full relative duration-75 transition-opacity transition-width ${
            window.innerWidth <= 640
              ? isOpen
                ? "opacity-100 w-full"
                : "opacity-0"
              : "opacity-100 w-full"
          }`}
        >
          {options.map((option) => (
            <NavItems
              key={option.id}
              hiddenNavItem={isOpen}
              active={isActiveNavItem === option.id}
              onClick={() => {
                handleNavItemClick(option.id);
                scrollToTop();
              }}
              icon={option.icon}
              title={option.title}
              url={option.url}
            />
          ))}
        </div>
        {/* Mobile */}
        <div
          className={`sm:hidden flex-col items-start justify-between space-x-2 relative duration-300 transition-opacity ${
            isOpen
              ? "opacity-100 w-full"
              : "opacity-0 w-0 z-0 h-0 overflow-hidden"
          }`}
        >
          {options.map((option) => (
            <NavItems
              key={option.id}
              hiddenNavItem={isOpen}
              active={isActiveNavItem !== null && isActiveNavItem === option.id}
              onClick={() => {
                handleNavItemClick(option.id);
                scrollToTop();
                if (option.id === 1) dispatch(setHomeActive());
                if (option.id === 2) dispatch(setProfileActive());
              }}
              activeSidebar={setIsOpen}
              icon={option.icon}
              title={option.title}
              url={option.url}
            />
          ))}
          {/* {isAuthenticated && (
            <button
              onClick={() => {
                toggleSidebar();
                openModal("invitarAmigos");
              }}
              className={`grid grid-flow-col grid-cols-6 ${
                isOpen ? "px-4 py-3" : "px-2 py-1"
              } select-none transition-colors duration-300 w-full bg-linear-to-r from-aw-green/75 to-transparent border-r-4 border-aw-green`}
            >
              <div
                className={`flex items-center justify-center ${
                  isOpen ? "col-span-1" : "col-span-full"
                } `}
              >
                <FontAwesomeIcon
                  icon={`fa-solid fa-user-plus`}
                  className={`text-lg text-white`}
                />
              </div>
              <span
                className={`text-sm text-left font-semibold tracking-[0.5em] col-span-5 transition-opacity ${
                  isOpen
                    ? "opacity-100 width-delay"
                    : "opacity-0 w-0 width-delay-open"
                }`}
              >
                Invitar Amigos
              </span>
            </button>
          )} */}
        </div>
        <div className="bg-gradient-to-br from-gray-900/5 to-black/35 sm:h-fit overflow-scroll sm:overflow-hidden mt-2 sm:mt-0">
          <ActiveUsers users={usersMock} hiddenNavItem={isOpen} />
        </div>
        {isAuthenticated && (
          <div className="sm:hidden flex flex-col items-center justify-center mt-4">
            {/* Botón para cerrar sesión en móvil */}
            <Link
              to="/"
              onClick={() => {
                dispatch(logoutUser());
                setIsOpen(false);
                scrollToTop();
              }}
              className={`${isOpen ? '' : 'hidden'} flex items-center gap-3 px-4 py-2 rounded-lg bg-gray-600 text-white focus:bg-aw-green focus:text-aw-bgbluedark mt-4 w-11/12 justify-center`}
            >
              <FontAwesomeIcon icon="fa-solid fa-right-from-bracket" />
              <span>Cerrar Sesión</span>
            </Link>
          </div>
        )}
      </div>

      {isAuthenticated && modals.invitarAmigos && (
        <Modal
          isOpen={modals.invitarAmigos}
          onClose={() => closeModal("invitarAmigos")}
          large="max-w-4xl sm:max-w-3xl xl:max-w-5xl"
        >
          <InvitarAmigos closeInvitarAmigos={closeModal} />
        </Modal>
      )}
    </>
  );
}
